module.exports = __webpack_public_path__ + "static/media/arrow-left-hover-state.861fa04a.svg";